/* @sravni/react-header version 0.2.43 */
var css = "._ce0cfd {\n  display: none;\n}\n@media screen and (min-width: 1160px) {\n  ._ce0cfd {\n    display: block;\n    position: absolute;\n    right: 0;\n  }\n}\n._ce0cfd iframe {\n  border: none;\n}\n";
var modules_3d0bf2ca = {"wrapper":"_ce0cfd"};
import "../../../assets/components/ContentWidget/index-aa219120.css";

export { css, modules_3d0bf2ca as default };
